import React, { useEffect, useState } from "react";
import MyContext from "./MyContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const MyContextProvider = ({ children }) => {
  const navigate = useNavigate();
const url = process.env.REACT_APP_API_URL || "https://api.durgaenterpriseglobal.com";

  const [data, setData] = useState([]);
  const [cart, setCart] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  /* LOAD USER FROM TOKEN */
  useEffect(() => {
    const loadUser = async () => {
      if (!token) {
        setUser(null);
        setAuthLoading(false);
        return;
      }

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setUser({ id: payload.id, email: payload.email });

        await loadCart();
      } catch (err) {
        console.error("Invalid token");
        localStorage.removeItem("token");
        setToken(null);
        setUser(null);
      }

      setAuthLoading(false);
    };

    loadUser();
  }, [token]);

  /* LOAD PRODUCT API */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${url}/api`);
        if (res.data.success) setData(res.data.data);
        else setError("Failed to load products");
      } catch {
        setError("Cannot connect to backend");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  /* LOAD CART */
  const loadCart = async () => {
    try {
      const res = await axios.get(`${url}/cart`);
      if (res.data.success) setCart(res.data.cart);
    } catch {
      console.log("Cart load failed");
    }
  };

  /* ADD TO CART */
  const addToCart = async (item) => {
    try {
      const res = await axios.post(`${url}/cart/add`, item);
      if (res.data.success) setCart(res.data.cart);
    } catch {
      console.log("Add to cart failed");
    }
  };

  /* UPDATE QUANTITY */
  const updateCartQty = async (productId, color, quantity) => {
    try {
      const res = await axios.put(`${url}/cart/update`, {
        productId,
        color: color || "",
        quantity,
      });
      if (res.data.success) setCart(res.data.cart);
    } catch {
      console.log("Update cart failed");
    }
  };

  /* REMOVE ITEM */
  const removeCartItem = async (productId, color) => {
    try {
      const res = await axios.delete(
        `${url}/cart/remove/${productId}/${color || ""}`
      );
      if (res.data.success) setCart(res.data.cart);
    } catch {
      console.log("Remove item failed");
    }
  };

  /* LOGIN */
  const loginUser = async (email, password) => {
    try {
      const res = await axios.post(`${url}/login`, { email, password });

      if (!res.data.success)
        return { success: false, error: res.data.error };

      const { token, user } = res.data.data;

      localStorage.setItem("token", token);
      setToken(token);
      setUser(user);

      navigate("/");
      return { success: true };
    } catch {
      return { success: false, error: "Login failed" };
    }
  };

  /* REGISTER */
  const registerUser = async (values) => {
    try {
      const res = await axios.post(`${url}/register`, values);
      return res.data;
    } catch {
      return { success: false, error: "Registration failed" };
    }
  };

  /* FORGOT PASSWORD */
  const requestReset = async (email) => {
    try {
      const res = await axios.post(`${url}/forgot-password`, { email });
      return res.data;
    } catch {
      return { success: false, error: "Failed to send reset link" };
    }
  };

  /* RESET PASSWORD */
  const resetPassword = async (token, newPassword) => {
    try {
      const res = await axios.post(`${url}/reset-password/${token}`, {
        newPassword,
      });
      return res.data;
    } catch {
      return { success: false, error: "Reset failed" };
    }
  };

  /* LOGOUT */
  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setCart([]);
    navigate("/");
  };

  const [adminAuth, setAdminAuth] = useState(
  localStorage.getItem("adminAuth") === "true"
);


  return (
    <MyContext.Provider
      value={{
        adminAuth, setAdminAuth,
        
        url,
        data,
        loading,
        error,

        loginUser,
        registerUser,
        requestReset,
        resetPassword,
        token,
        user,
        authLoading,
        logout,
        navigate,

        cart,
        loadCart,
        addToCart,
        updateCartQty,
        removeCartItem,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyContextProvider;
